import ReactGA from 'react-ga4';

export const initGA = () => {
  ReactGA.initialize('G-V61M6PMF2Q'); // your GA4 Measurement ID
};

export const trackPageview = (path: string) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};

export const trackEvent = ({
  category,
  action,
  label,
  value
}: {
  category: string;
  action: string;
  label?: string;
  value?: number;
}) => {
  ReactGA.event({ category, action, label, value });
};

export const trackError = (error: unknown, context?: string) => {
  const e = error instanceof Error ? error : new Error(String(error));
  ReactGA.event({
    category: 'Error',
    action: e.message,
    label: context,
    nonInteraction: true
  });
};

export const trackSignalR = (
  action: string,
  label?: string,
  value?: number
) => {
  try {
    ReactGA.event({
      category: 'SignalR',
      action: `${action} ${new Date().toISOString()}`,
      label,
      value,
      nonInteraction: true
    });
  } catch (e) {
    console.log('[GA] LOG FAILED');
  }
};
